import React, { useState } from "react"
import {
  InputReason,
  Order,
  OrderModificationShippingFees,
  ShippingFeeModificationUpdateData
} from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import { handleErrorMessages } from "helpers/errors"
import Reason from "../../../Reason/Reason"
import { ModificationShippingFees } from "../../../../../../classes/order/ModificationShippingFees"
import UPDATE_SHIPPING_FEE_MODIFICATION from "../../../../../../graphql/mutations/order/modification/shippingFees/UpdateModification"
import { ReasonType } from "lib/types/order"
import { isSkipReason } from "../../../../helpers"

type Props = {
  modification: OrderModificationShippingFees
  refetch: () => void
  order: Order
  orderLoading: boolean
}

const ModificationReason = ({ modification, refetch, order, orderLoading }: Props) => {
  const [reasonType, setReasonType] = useState<ReasonType | undefined>(
    !modification?.reason ? ReasonType.SKIP : undefined
  )
  const modifications = new ModificationShippingFees(
    order.Modifications as OrderModificationShippingFees[]
  )

  const [updateModification, { loading }] = useMutation(UPDATE_SHIPPING_FEE_MODIFICATION, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const addReason = (reason: InputReason) => {
    updateModification({
      variables: {
        modificationId: modification.id,
        input: {
          shippingFees: modification.shippingFees.map((shippingFee) => ({
            ...shippingFee,
            data: JSON.stringify(
              modifications.updateOutputToInput(
                shippingFee.data as ShippingFeeModificationUpdateData
              )
            )
          })),
          ...(reason.cause && reason.code && !isSkipReason(reasonType) && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateModification({
      variables: {
        modificationId: modification.id,
        input: {
          shippingFees: modification.shippingFees.map((shippingFee) => ({
            ...shippingFee,
            data: JSON.stringify(
              modifications.updateOutputToInput(
                shippingFee.data as ShippingFeeModificationUpdateData
              )
            )
          })),
          reason: null
        }
      }
    }).then(() => setReasonType(ReasonType.SKIP))
  }
  return (
    <Reason
      addReason={addReason}
      reasonType={reasonType}
      setReasonType={setReasonType}
      removeReason={removeReason}
      orderReason={modification.reason}
      loading={loading}
      orderLoading={orderLoading}
    />
  )
}

export default ModificationReason
